module.exports = __webpack_public_path__ + "img/nodata.c626ddf0.png";